// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__mVNkc","empty":"ModalGraph_empty__9XLUr"};